import type { PropsWithChildren } from 'react';
import type { Data } from '../../types.js';
import SchemaForm, { type SchemaFormOwnProps, type SchemaFormProps } from './schema-form.js';
import { useSchemaForm } from './schema-form-hook.js';

export { FormContext } from './schema-form.js';

function ConnectedSchemaForm<T extends Data = Data>(props: PropsWithChildren<SchemaFormOwnProps<T>>) {
  const combined: SchemaFormProps<T> = { ...props, ...useSchemaForm(props) };
  return <SchemaForm {...combined} />;
}

ConnectedSchemaForm.displayName = 'ConnectHook(SchemaForm)';

export default ConnectedSchemaForm;
